import { getConstant, getVersion } from '@utils/constants';

function getYear() {
  const year = new Date().getFullYear();
  return year > 2015 ? `2015-${year}` : year;
}

export default function Footer({ children = null, ...props }) {
  props.className = `${props?.className || ''} footer-wrapper bg-primary d-flex flex-column`;

  return (
    <footer {...props}>
      {children}

      <div className="mx-auto text-white py-3 text-xs">
        <div className="d-flex flex-column px-3 text-center">
          <p className="m-0">
            {getYear()} &copy; {getConstant('sitename')}
            <span className="d-none d-md-inline px-2">-</span>
            <span className="d-block d-md-none" />
            Todas as informações são confidenciais.
            <span className="d-none d-md-inline px-2">-</span>
            <span className="d-block d-md-none" />
            <a href="https://status.fortesec.tech" target="_blank" className="text-white">Status</a>
          </p>
        </div>
      </div>

      <span className="footer-version">
        Versão { getVersion() }
      </span>
    </footer>
  );
}
